/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ResolveReservationRequest
 */
export interface ResolveReservationRequest {
    /**
     * The Gondola-internal numeric booking id (as a string).
     * @type {string}
     * @memberof ResolveReservationRequest
     */
    bookingId: string;
}

/**
 * Check if a given object implements the ResolveReservationRequest interface.
 */
export function instanceOfResolveReservationRequest(value: object): value is ResolveReservationRequest {
    if (!('bookingId' in value) || value['bookingId'] === undefined) return false;
    return true;
}

export function ResolveReservationRequestFromJSON(json: any): ResolveReservationRequest {
    return ResolveReservationRequestFromJSONTyped(json, false);
}

export function ResolveReservationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResolveReservationRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'bookingId': json['booking_id'],
    };
}

export function ResolveReservationRequestToJSON(json: any): ResolveReservationRequest {
    return ResolveReservationRequestToJSONTyped(json, false);
}

export function ResolveReservationRequestToJSONTyped(value?: ResolveReservationRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'booking_id': value['bookingId'],
    };
}

